export class spSite_Client_By_Domain {
    public constructor(init?: Partial<spSite_Client_By_Domain>) {Object.assign(this, init);}
    allow_amex: boolean;
    auto_maintenance_message: string;
    contact_information: string;
    court_name: string;
    credit_card_mode_message: string;
    enable_pbv: boolean;
    home_url: string;
    is_active: boolean;
    is_allow_auto_maintenance: boolean;
    is_allow_auto_maintenance_online: boolean;
    is_available: boolean;
    is_display_name_on_header: boolean;
    is_in_auto_maintenance: boolean;
    is_in_site_maintenance: boolean;
    is_online: boolean;
    maintenance_message: string;
    payment_plan_minimum_per_ticket: number;
    plus_fee: number;
    refund_policy: string;
    retail_descriptor: string;
    search_message: string;
    search_message2: string;
    search_panel_header: string;
    site_id: string;
    site_name: string;
    subdomain: string;
    terms_of_service: string;
    theme: string;
    ticket_title: string;
}

